import React, { useContext } from "react";
import {
  Text,
  LegacyCard as Card,
  Collapsible,
  ColorPicker,
  Layout,
  InlineStack,
  TextField,
  BlockStack,
  Box,
} from "@shopify/polaris";

// import hoc
import { withErrorBoundary } from "lib/hoc";

// import constant
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// import context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const ToastText = () => {
  const {
    color,
    errorMessage,
    handleChange,
    hex,
    // learnMore,
    resetDefault,
  } = useContext(BrandingContext);

  const { cms = () => {}, currentUser } = useContext(PrivateContext);

  const { updatedAt = "" } = currentUser || {};
  const { HEX, COLOR, TOAST_TEXT, DEFAULT_TOAST_TEXT_COLOR } = constant;

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.toastTextColor.title")}
        description={cms("section.toastTextColor.description")}
      >
        <Card
          title={[
            cms("section.toastTextColor.title"),
            updatedAt && (
              <Text as="span" tone="subdued">
                <Text variant="bodySm" as="p">{`${baseHelper.lastUpdateDate(updatedAt)}`}</Text>
              </Text>
            ),
          ]}
        >
          <Card.Section>
            <BlockStack gap="2">{cms("section.toastTextColor.subDescription")}</BlockStack>
            <br />
            <InlineStack align="space-between">
              <Box width="60%">
                <BlockStack>
                  <TextField
                    label={cms("section.toastTextColor.label.hexCode")}
                    value={hex.toastTextHex}
                    onChange={(value) => handleChange(TOAST_TEXT, value, HEX)}
                    labelAction={
                      hex.toastTextHex !== DEFAULT_TOAST_TEXT_COLOR && {
                        content: cms("label.reset"),
                        onClick: () => resetDefault(TOAST_TEXT, DEFAULT_TOAST_TEXT_COLOR, HEX),
                      }
                    }
                    error={errorMessage && errorMessage.toastText}
                  />
                  <br />
                  <Text as="span" variant="bodySm">
                    <div
                      style={{
                        borderRadius: ".5rem",
                        width: "max-content",
                        height: "28px",
                        background: hex.toastBackgroundHex,
                        color: hex.toastTextHex,
                        textAlign: "center",
                        padding: "6px 12px",
                      }}
                    >
                      {cms("section.toastTextColor.label.sampleHeader")}
                    </div>
                  </Text>
                </BlockStack>
              </Box>
              <ColorPicker onChange={(value) => handleChange(TOAST_TEXT, value, COLOR)} color={color.toastTextColor} />
            </InlineStack>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withErrorBoundary(ToastText);
